import OrcamentoTimeline from "@/modules/OrcamentoTimeline/Index.vue";

export default [
  {
    path: "/orcamento-timeline",
    name: 'orcamentoTimeline',
    component: OrcamentoTimeline,
  },
];
